import { BrowserRouter, Route, Routes } from "react-router-dom";
import { LoginScreen } from "../LoginScreen";
import { PublicRoute } from "./PublicRoute";
import { ProtectedRoute } from "./ProtectedRoute";
import { Practice } from "../Pages/Practice";
import { Icons } from "../Pages/Icons";
import LayoutDefault from "../../VideoWall/Layouts/LayoutDefault";
import  Map  from "../Pages/Map";
import { Config } from "../Pages/Configurations/Config";
import { Home } from "../Pages/Home";
import LayoutMap from "../../VideoWall/Layouts/LayoutMap";

export default function RoutesSwitcher(){
    return(
        <BrowserRouter>
            <Routes>
                <Route element={<PublicRoute/>}>
                    <Route path ="/" element={<LoginScreen/>} />
                </Route>
                <Route element={<ProtectedRoute />}>
                    <Route path="/videowall" element={<LayoutDefault />} />
                    {/* <Route path="/videowall_map" element={<LayoutMap />} /> */}
                    {/* <Route path="/home" element={<Home />} /> */}
                    <Route path="/configuarations" element={<Config />} />
                    <Route path="/practice" element={<Practice />} />
                    <Route path="/icons" element={<Icons />} />
                    <Route path="/map" element={<Map />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
};